// IMPORTANT: This file's SCORECARD_WEIGHTS and SCORECARD_TARGETS are duplicated at:
// - app/constants/technician-scorecard.ts
// - mobile/src/global/types/technician-scorecard.ts
// Please keep all three files in sync when making changes

const SCORECARD_WEIGHTS = {
  driverSafetyWeight: 'driver-safety-weight',
  qualityScoreWeight: 'quality-score-weight',
  onTimeClockInPercentageWeight: 'on-time-clock-in-percentage-weight',
  averageCustomerRatingWeight: 'average-customer-rating-weight',
  percentageOfJobsRatedByCustomersWeight:
    'percentage-of-jobs-rated-by-customers-weight',
  installationAuditPassPercentageWeight:
    'installation-audit-pass-percentage-weight',
  averageFourTireInstallTimeWeight: 'average-four-tire-install-time-weight',
  mileageCapturePercentageWeight: 'mileage-capture-percentage-weight',
}

const SCORECARD_TARGETS = {
  percentageOfJobsRatedByCustomersTarget:
    'percentage-of-jobs-rated-by-customers-target',
  averageFourTireInstallTimeTarget: 'average-four-tire-install-time-target',
  mileageCapturePercentageTarget: 'mileage-capture-percentage-target',
  rawQualityScoreTarget: 'raw-quality-score-target',
  rawQualityScoreCutoffTarget: 'raw-quality-score-cutoff-target',
}

const ENTRY = {
  employeeId: 'Employee ID:',
  tenure: 'Tenure:',
  driverSafetyScore: 'Driver Safety Score:',
  numberOfHarshEvents: 'Number of Harsh Events:',
  milesDriven: 'Miles Driven:',
  speedingTimeTotalTime: 'Speeding time / Total time:',
  weight: 'Weight:',
  customerRatingScore: 'Customer Rating Score:',
  numberOfJobsRated: 'Number of Jobs Rated by Customers:',
  averageCustomerRating: 'Average Customer Rating:',
  installationAuditScore: 'Installation Audit Score:',
  percentPassingInstallationAudits: '% Passing Installation Audits:',
  fourTireInstallationScore: '4-Tire Installation Score:',
  mileageCaptureScore: 'Mileage Capture Score:',
  onTimeClockInScore: 'On-Time Clock-In Score:',
  percentOnTimeClockIns: '% On-Time Clock-Ins:',
  qualityScore: 'Quality Score:',
  qualifyingDefects: 'Qualifying Defects:',
  totalInstallations: 'Total Installations:',
  overallScore: 'Overall Score:',
  overallRank: 'Overall Rank:',
}

const SECTION = {
  driverSafety: 'Driver Safety',
  customerRating: 'Customer Rating',
  installationAudits: 'Installation Audits',
  fourTireInstallTime: '4-Tire Install Time',
  mileageCapture: 'Mileage Capture',
  onTimeClockIn: 'On-Time Clock-In',
  qualityScore: 'Quality Score',
}

export { SCORECARD_WEIGHTS, SCORECARD_TARGETS, ENTRY, SECTION }
